import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TranslocoService } from '@jsverse/transloco';
import { NotificationService } from '@core/services/notification.service';
import { LoggerService } from '@core/services/logger.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(
        private notificationService: NotificationService,
        private logger: LoggerService,
        private translocoService: TranslocoService
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                // Log full error
                this.logger.error('HTTP Error', {
                    status: error.status,
                    statusText: error.statusText,
                    url: error.url,
                    message: error.message,
                    error: error.error
                });

                this.notificationService.showError(this.getMessage(error));

                return throwError(() => null);
            })
        );
    }

    private getMessage(error: HttpErrorResponse): string {
        if (error.error != null) {
            if (typeof error.error === 'string' && error.error.trim()) {
                return error.error;
            }
            if (typeof error.error === 'object' && error.error.message) {
                return error.error.message;
            }
        }

        if (error.statusText != null && error.statusText.trim()) {
            return error.statusText;
        }

        return this.translocoService.translate('httpErrorInterceptor.unknownError');
    }
}
